import React, { useEffect, useState, useRef, useCallback } from 'react';
import CardOverViewGrid from './CardOverViewGrid';
import { Alert, message } from 'antd';
import apiCalls from 'src/api/apiCalls';
import Filter from './filter';
import dayjs from 'dayjs';
import HeaderComponent from 'src/components/header';
const Cards = () => {
  const [filterValues, setFilterValues] = useState({ "status": "All", "freeSearch": null, "startDate": null, "endDate": null });
  const [statusLuData, setStatusLuData] = useState([])
  const [errorMessage, setErrorMessage] = useState(null)
  const [isExcelExport, setIsExcelExport] = useState(false);
  const shouldLog = useRef(true);
  const refreshRef = useRef();
  const breadCrumbList = [
    { bname: 'Cards' },
  ]
  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      statusLookUp()
    }
  }, [])
  const statusLookUp = async () => {
    try {
      const response = await apiCalls.getLookups(`/CardsActivityService/CardsStateLu`);
      if (response.ok) {
        setStatusLuData(response?.data?.CardsState);
        setErrorMessage(null);
      } else {
        setStatusLuData([]);
        setErrorMessage(apiCalls.isErrorDispaly(response));
      }
    } catch (error) {
      setErrorMessage(error);
    }
  }
  const handleSearch = useCallback((values) => {
    let formattedDates = null;
    if (values?.dateRange) {
      formattedDates = values?.dateRange ? values?.dateRange?.map(date => dayjs(date).format('YYYY-MM-DD')) : null
    }
    setFilterValues({
      Status: values?.Status || "All",
      freeSearch: values?.freeSearch,
      startDate: formattedDates ? formattedDates[0] : null,
      toDate: formattedDates ? formattedDates[1] : null,
    });
  }, [])
  const handleExcelExport = useCallback(() => {
    setIsExcelExport(true);
    setTimeout(() => {
      setIsExcelExport(false)
    });
    message.destroy();
    message.success({
      content: 'Download Excel Successfully',
      className: 'custom-msg',
      duration: 3
    });
  }, []);
  const closeError = useCallback(() => {
    setErrorMessage(null)
  }, [])

  return (
    <div className=''>
      <HeaderComponent breadCrumbList={breadCrumbList} />
      {errorMessage !== null && (
        <Alert
          className='mb-6'
          type="error"
          description={errorMessage}
          onClose={closeError}
          showIcon
          closable
        />
      )}
      <div className=''>
        <Filter handleExcelExport={handleExcelExport} filterObj={handleSearch} filterValues={filterValues} stateLu={statusLuData} onloadGrid={refreshRef?.current?.loadGrid} />
      </div>
      <CardOverViewGrid filterValues={filterValues} ref={refreshRef} isExcelExport={isExcelExport} />
    </div>
  )
}
export default Cards;